import { useMemo } from 'react';
import { useUserHasConsignorMasterUI } from 'src/hooks/useUserIsConsignorMasterUI';

import { useSellerRoleContext } from './SellerRoleContext';

export const useSellerRolesForSelection = (
  consigneeSellerAccountId?: string | null
) => {
  const { allSellerRoles } = useSellerRoleContext();

  const hasConsignorMasterUI = useUserHasConsignorMasterUI();

  if (!hasConsignorMasterUI) {
    consigneeSellerAccountId = null;
  }

  const allSellerRolesForSelection = useMemo(
    () =>
      Object.values(allSellerRoles ?? {})
        .filter(
          (r) =>
            !r.isDeleted &&
            (r.consigneeSellerAccountId == null ||
              consigneeSellerAccountId == null ||
              r.consigneeSellerAccountId === consigneeSellerAccountId)
        )
        .reduce(
          (r, cur) => {
            r[cur.id] = cur.name;
            return r;
          },
          {} as Record<string, string>
        ),
    [allSellerRoles, consigneeSellerAccountId]
  );

  return { allSellerRolesForSelection };
};
